// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3824":"e1af3b92","9553":"58297519","9721":"e1af3b92"}[chunkId] + ".chunk.css";
};